import {  MODULE_LIST, MODULE_DETAILS } from './../constant/ActionTypes';

export const moduleReducer = (state, action) => {
    switch (action.type) {
        case MODULE_LIST:
            return { ...state, moduleList: action.payload };
        case MODULE_DETAILS:
            return { ...state, moduleDetails: action.payload };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/moduleReducer.js